"use client";
import SectionHeader from "@/components/common/section-header";
import React, { useEffect, useState } from "react";
import { isa_messageEN } from "@/assets/dictionaries/en/isa-content";
import { isa_messageES } from "@/assets/dictionaries/es/isa-content";

const IsaMessage = () => {
  const [isaMessageContent, setIsaMessageContent] = useState(isa_messageEN); // Default to English

  useEffect(() => {
    // Get the language from localStorage
    const lang = localStorage.getItem("selectedOption") || "EN"; // Default to EN if not found

    // Set the content based on the language
    switch (lang.toUpperCase()) {
      case "ES":
        setIsaMessageContent(isa_messageES);
        break;
      case "EN":
      default:
        setIsaMessageContent(isa_messageEN);
        break;
    }
  }, []); // Only run on mount
  return (
    <div className="pt-16">
      <SectionHeader>
        <div className="text-gbci-accent max-w-[240px] md:max-w-none">
          {isaMessageContent.message_title}
        </div>
      </SectionHeader>
      <div className="text-white text-xl text-center my-20">
        {isaMessageContent.message_desc}
      </div>
    </div>
  );
};

export default IsaMessage;
